import { OPERATORS } from 'src/app/services/constants';
import { BandTooltipStrategy } from './band-tooltip-strategy.interface';

export class PixxelBandTooltipStrategy implements BandTooltipStrategy {
  matches(operatorKey: string, operatorMetadata: any, taskSensor: any): boolean {
    console.log('PixxelBandTooltipStrategy.matches called with:', { operatorKey, operatorMetadata, taskSensor });
    return operatorKey === OPERATORS.PIXXEL && !!taskSensor?.selectedBands;
  }

  buildTooltip(operatorMetadata: any, taskSensor: any): string {
    console.log('PixxelBandTooltipStrategy.buildTooltip called with:', { operatorMetadata, taskSensor });
    const selectedBandId = taskSensor?.selectedBands;
    if (!selectedBandId) {
      return '';
    }
    // Richest path: actual selected bands are stored in the order request bandset
    const orderBandset = taskSensor?.orderRequest?.order_items?.bandset;
    if (orderBandset?.bands?.length) {
      const bandLines = (orderBandset.bands as any[]).map((b: any) =>
        b.wavelength ? `${b.name} (${b.wavelength} nm)` : b.name
      );
      return `Selected ${orderBandset.bands.length} bands: ${bandLines.join(', ')}`;
    }
    // sensorPolicy path: no bands array, fall back to the operator-level tooltip
    if (!Array.isArray(operatorMetadata?.bands)) {
      return operatorMetadata?.tooltip || '';
    }
    // Enriched path: /sensors/... injects operatorMetadata.bands with full band-set details
    const selectedBandSet = operatorMetadata.bands.find((band: any) => band.id === selectedBandId);
    if (!selectedBandSet) {
      return operatorMetadata?.tooltip || '';
    }
    const lines: string[] = [];
    if (selectedBandSet.name) {
      lines.push(selectedBandSet.name);
    }
    if (selectedBandSet.description && selectedBandSet.description !== selectedBandSet.name) {
      lines.push(selectedBandSet.description);
    }
    const bandsetLines = (selectedBandSet.bandset || []).flatMap((windowGroup: any) =>
      Object.entries(windowGroup || {}).map(([windowName, bands]) => {
        const formattedBands = (bands as any[])
          .map((band: any) => `${band.name}${band.wavelength ? ` (${band.wavelength} nm)` : ''}`)
          .join(', ');
        return formattedBands ? `${windowName}: ${formattedBands}` : '';
      })
    );
    lines.push(...bandsetLines.filter(Boolean));
    return lines.join('\n');
  }
}
